import FirestoreDocument from "../../../types/FirestoreDocument";
import { any, boolean, nullable, number, object, record, string, timestamp } from "../../../types/_types";

import { CostMeta, costMetaByPriceType } from "./CostMeta";

// Refs keep their unlisted fields: their shape has varied, and the UI reads more than is listed here.

const CostOrganizationRef = FirestoreDocument.extend({
	name: nullable(string()),
	type: nullable(string()),
}).passthrough();

const CostPartyRef = FirestoreDocument.extend({
	name: nullable(string()),
	type: nullable(string()),
	email: nullable(string()),
	img: nullable(string()),
	vendor: nullable(any()),
}).passthrough();

const CostAgreementRef = FirestoreDocument.extend({
	name: nullable(string()),
	type: nullable(string()),
	part: nullable(string()),
	status: nullable(string()),
}).passthrough();

const CostProductionRef = FirestoreDocument.extend({
	title: nullable(string()),
}).passthrough();

// A hidden price has no amount.
const CostPrice = object({
	id: nullable(string()),
	ref: nullable(any()),
	name: nullable(string()),
	type: string(),
	unit: nullable(string()),
	price: nullable(number()),
	currency: nullable(string()),
	vat: number().default(0),
}).passthrough();

const CostEstimation = object({
	value: number(),
	exchanged: number(),
});

const CostExchange = object({
	rate: number(),
	value: number(),
	currency: string(),
	exchangeRateId: nullable(string()),
});

export const Cost = FirestoreDocument.extend({
	activity: number(),
	agreement: nullable(CostAgreementRef),
	amount: number(),
	amountProduced: number(),
	// Finalized amount per price id, when a cost combines several prices.
	amounts: record(string(), nullable(number())),
	created: timestamp(),
	deleted: boolean(),
	employee: boolean(),
	estimation: nullable(CostEstimation),
	exchange: nullable(CostExchange),
	expense: boolean(),
	firstParty: nullable(CostPartyRef),
	meta: nullable(CostMeta),
	orderId: nullable(string()),
	price: nullable(CostPrice),
	processed: boolean(),
	producer: nullable(CostOrganizationRef),
	production: nullable(CostProductionRef),
	publisher: nullable(CostOrganizationRef),
	secondParty: nullable(CostPartyRef),
	total: number(),
	totalIncVat: number(),
	totalVat: number(),
	value: number(),
}).superRefine((cost, context) => {
	// Only price types in costMetaByPriceType have a meta, in that shape.
	const schema = costMetaByPriceType[cost.price?.type];

	if (!schema && cost.meta) {
		context.addIssue({ code: "custom", path: ["meta"], message: `No meta expected for ${cost.price?.type}` });
	}

	if (schema && !schema.safeParse(cost.meta).success) {
		context.addIssue({ code: "custom", path: ["meta"], message: `Invalid meta for ${cost.price?.type}` });
	}
});
